// notificationTimerManager.ts
let activeInterval: NodeJS.Timeout | null = null;
let timerNotificationId: string | null = null;

export function getTimerNotificationId() {
  return timerNotificationId;
}

export function setTimerNotificationId(id: string | null) {
  timerNotificationId = id;
}

export function setActiveInterval(interval: NodeJS.Timeout | null) {
  activeInterval = interval;
}

export function stopTimerNotification() {
  if (activeInterval) {
    clearInterval(activeInterval);
    activeInterval = null;
  }

  if (timerNotificationId) {
    const id = timerNotificationId;
    timerNotificationId = null;
    return id;
  }

  return null;
}
